import { DestroyRef, inject } from '@angular/core';

export const FILTER_PANEL_OPEN_QUERY = '(min-width: 64em)';

let panelInstanceCount = 0;

export class FilterPanelState {
    readonly panelId: string = `dgh-filter-panel-${++panelInstanceCount}`;

    private openState: boolean;
    private handSet = false;

    constructor(openByDefault: boolean) {
        this.openState = openByDefault;
    }

    get open(): boolean {
        return this.openState;
    }

    toggle(): void {
        this.handSet = true;
        this.openState = !this.openState;
    }

    show(): void {
        this.handSet = true;
        this.openState = true;
    }

    applyViewportDefault(openByDefault: boolean): void {
        if (this.handSet) {
            return;
        }

        this.openState = openByDefault;
    }
}

export function filterPanelForViewport(view: Window = window): FilterPanelState {
    const query: MediaQueryList | undefined = view.matchMedia?.(FILTER_PANEL_OPEN_QUERY);
    const state: FilterPanelState = new FilterPanelState(query ? query.matches : true);

    if (query) {
        const onViewportChange = (event: MediaQueryListEvent): void => state.applyViewportDefault(event.matches);

        query.addEventListener('change', onViewportChange);
        inject(DestroyRef).onDestroy(() => query.removeEventListener('change', onViewportChange));
    }

    return state;
}
